import styles from './styles.module.css';
import { format } from 'date-fns';
import { ja } from 'date-fns/locale';
import LoginLayout from '../../LoginLayout';

type Props = {
  title: string;
  message: string;
  startAt: Date;
  endAt: Date;
};

function Maintenance({ title, message, startAt, endAt }: Props) {
  return (
    <LoginLayout wide>
      <div className={styles.box}>
        <div className={styles.title}>{title}</div>
        <div>
          <div className={styles.termsLabel}>メンテナンス期間</div>
          <Terms startAt={startAt} endAt={endAt} />
        </div>
        <Message text={message} />
      </div>
    </LoginLayout>
  );
}

export default Maintenance;

function Message({ text }: { text: string }) {
  const lines = text.split('\n');
  const elems = [];
  for (let i = 0; i < lines.length; i++) {
    elems.push(<>{lines[i]}</>);
    if (i !== lines.length - 1) {
      elems.push(<br />);
    }
  }
  return <div className={styles.message}>{elems}</div>;
}

/**
 * メンテナンス期間の開始と終了の日時を表示する
 *
 * 開始と終了の日付が同じ場合は 1 行で表示する
 */
function Terms({ startAt, endAt }: { startAt: Date; endAt: Date }) {
  const start = formatDate(startAt);
  const end = formatDate(endAt);
  return (
    <div className={styles.terms}>
      {start[0] === end[0] ? (
        <>
          {start.join(' ')} - {end[1]}
        </>
      ) : (
        <>
          {start.join(' ')} -<br />
          {end.join(' ')}
        </>
      )}
    </div>
  );
}

function formatDate(d: Date): [date: string, time: string] {
  const fmt = (f: string) => format(d, f, { locale: ja });
  const period = d.getHours() < 12 ? 'AM' : 'PM';
  return [fmt('yyyy/M/d(E)'), `${period}${fmt('h:mm')}`];
}
